import { PersistStorage, StateStorage } from 'zustand/middleware';

export const shouldUseExtensionStorage =
  typeof chrome !== 'undefined' && typeof chrome?.storage !== 'undefined';

export const customExtensionStorage:
  | StateStorage
  | PersistStorage<Record<string, string>> = {
  getItem: name => {
    if (!chrome || !chrome.storage) return null as any;

    return new Promise<any>(res =>
      chrome.storage.local.get(name, result => {
        try {
          const value = result[name];
          if (typeof value !== 'string') return res(null);
          res(JSON.parse(value));
        } catch (error) {
          console.warn(error);
          res(null);
        }
      })
    );
  },
  setItem: (name: string, value: string) => {
    if (!chrome || !chrome.storage) return null as any;

    chrome.storage.local.set({ [name]: JSON.stringify(value) });
  },
  removeItem: name => {
    if (!chrome || !chrome.storage) return null as any;

    chrome.storage.local.remove(name);
  },
};
